import React from 'react';

import Counter from '../../components/Counter/Counter';
import { useTranslation } from 'react-i18next';
import logger from '../../logger';

const Example = () => {
  const { t } = useTranslation();
  const { line1, line2 } = t('txt');

  function handleClick() {
    logger.debug('Button clicked');
  }

  return (
    <div className="App">
      <Counter />
      <h2 onClick={handleClick}>{line1}</h2>
      <h2>{line2}</h2>
    </div>
  );
};

export default Example;
